// 存储用户基本信息
const userStore = {
  namespaced: true,
  state: {
    isSign: undefined, // 是否签到
    dataList: [],
    userInfo: sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user")) : {}, // 当前登录用户的个人信息
    curUserInfo: {},  // 当前访问个人中心的用户信息 可能是自己，也可能是别人
    curActiveTab: 0, // 当前激活的tab
    loading: true, // 当前骨架屏加载状态
    // 列表请求是否在飞行中。与 loading 的区别：loading 只在首屏（列表为空）时置位，
    // 用来控制骨架屏；listFetching 每次请求都置位，用于并发保护和无限滚动组件解锁
    listFetching: false,
    curPagination: {
      current: 1,
      pages: 1,
      total: 1
    },
    // 新增：tab 数据缓存
    tabDataCache: {
      // 0: { dataList: [], pagination: {} },
      // 1: { dataList: [], pagination: {} },
      // ...
    }
  },
  mutations: {
    setSignState(state, newValue) {
      state.isSign = newValue
    },
    setDataList(state, data) {
      state.dataList = data
    },
    setUserInfo(state, newValue) {
      state.userInfo = newValue
      sessionStorage.setItem("user", JSON.stringify(newValue))
    },
    setCurUserInfo(state, newValue) {
      state.curUserInfo = newValue
    },
    setCurActiveTab(state, newValue) {
      state.curActiveTab = newValue
    },
    setSkeletonLoading(state, newValue) {
      state.loading = newValue
    },
    setListFetching(state, newValue) {
      state.listFetching = newValue
    },
    setPagination(state, newValue) {
      Object.assign(state.curPagination, newValue)
    },
    // 新增：缓存当前 tab 数据
    cacheTabData(state, { tab, dataList, pagination }) {
      state.tabDataCache = {
        ...state.tabDataCache,
        [tab]: {
          dataList: [...dataList],
          pagination: { ...pagination }
        }
      }
    },
    // 新增：从缓存恢复数据
    restoreTabData(state, tab) {
      const cached = state.tabDataCache[tab]
      if (cached) {
        state.dataList = [...cached.dataList]
        state.curPagination = { ...cached.pagination }
      }
    },
    // 新增：清空缓存
    clearTabCache(state) {
      state.tabDataCache = {}
    },
    // 新增：清空单个 tab 的缓存
    clearSingleTabCache(state, tab) {
      if (state.tabDataCache[tab]) {
        const newCache = { ...state.tabDataCache }
        delete newCache[tab]
        state.tabDataCache = newCache
      }
    },
    // 新增：更新列表中的单个项目（用于点赞、收藏等操作）
    updateListItem(state, { id, updates }) {
      const index = state.dataList.findIndex(item => item.id === id)
      if (index !== -1) {
        state.dataList.splice(index, 1, {
          ...state.dataList[index],
          ...updates
        })
      }
    }
  },
  modules: {
    // user: userStore
  },
  actions: {

  },
  getters: {
    schoolChooseVisible({ userInfo }) {
      // 用户已登录并且没有schoold时才显示
      return !!userInfo?.id && !userInfo.schoolId
    },
    // 新增：检查是否有缓存
    hasTabCache: (state) => (tab) => {
      return !!state.tabDataCache[tab]
    }
  }
}
export default userStore